// Generated by ts-to-zod
import { z } from 'zod';
import { formulaSummaryPayloadSchema } from './schemas/formulaSummary.schema';

export const summaryBlockSchema = z.object({
  keyword: z.string(),
  summary: z.string(),
});

export const querySummarySchema = z.object({
  title: z.string(),
  subtitle: z.string(),
  blocks: z.array(summaryBlockSchema),
});

export const computedFieldSummaryResponseSchema = z.object({
  results: z.array(
    z.object({
      summary: z.array(querySummarySchema),
    })
  ),
});

export const computedFieldSummaryPayloadSchema = formulaSummaryPayloadSchema;
